export default { sha: '0e517838141fcd36d87464c3d1cc3190462afa54', buildNumber: 'undefined' }
